"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const reactstrap_1 = require("reactstrap");
const react_1 = __importDefault(require("react"));
const Stringify_1 = require("./Stringify");
exports.ListComponent = ({ data, className, col }) => {
    const _data = data.map((d) => ({
        label: d.label || d,
        value: d.value || d,
    }));
    return (react_1.default.createElement(react_1.default.Fragment, null, _data.map((x) => (react_1.default.createElement(reactstrap_1.NavItem, { className: className, key: x.value },
        react_1.default.createElement(Stringify_1.Stringify, { col: col, value: x.label }))))));
};
//# sourceMappingURL=ListComponent.js.map